import React from 'react'
import './Home.scss'
import { homeData } from '../../data/homeData'
import { Link, useNavigate } from 'react-router-dom'
import getPermission from '../../utils/helpers/getPermissions'
import { rolesId } from '../../const/constants'
import { RECOMMENDATIONS_ENDPOINT } from '../../routes/route'



function Home() {
  const navigate = useNavigate();
  const isTherapist = (JSON.parse(localStorage.getItem('UserData')))?.user_role_id === rolesId.THERAPIST;

  if(isTherapist){
    navigate(RECOMMENDATIONS_ENDPOINT);
    return ;
  }
  
  return (
    <div className='container'>
        <div className="home">
            <div className="row">
              {
                homeData?.map((item, index)=>(
                  (!item.permissionKey || getPermission(item.permissionKey)!=="hide") ?
                  <div className="col-6" key={index}>
                    <Link to={item.path} className="block">
                      {item.icon}
                      {item.title}
                    </Link>
                  </div>
                  :
                  <></>
                ))
              }
              {/* {
                getPermission(homeData[4].permissionKey) &&
                <div className="col-12">
                  <Link to={homeData[4].path} className="block">
                    {homeData[4].icon}
                    {homeData[4].title}
                  </Link>
                </div>
              } */}
            </div>
        </div>
    </div>
  )
}

export default Home